/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_ExperienceInputs */

const en_us2_search_field_experience = /** @type {(inputs: Search_Field_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lifting experience`)
};

const pt_br2_search_field_experience = /** @type {(inputs: Search_Field_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experiência com pesos`)
};

const es_419_search_field_experience = /** @type {(inputs: Search_Field_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experiencia con pesas`)
};

const pt_pt2_search_field_experience = /** @type {(inputs: Search_Field_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experiência com pesos`)
};

const fr_fr2_search_field_experience = /** @type {(inputs: Search_Field_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expérience en musculation`)
};

const de_de2_search_field_experience = /** @type {(inputs: Search_Field_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Krafttrainingserfahrung`)
};

const it_it2_search_field_experience = /** @type {(inputs: Search_Field_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esperienza con i pesi`)
};

/**
* | output |
* | --- |
* | "Lifting experience" |
*
* @param {Search_Field_ExperienceInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_experience = /** @type {((inputs?: Search_Field_ExperienceInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_ExperienceInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_experience(inputs)
	if (locale === "es-419") return es_419_search_field_experience(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_experience(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_experience(inputs)
	if (locale === "de-DE") return de_de2_search_field_experience(inputs)
	if (locale === "it-IT") return it_it2_search_field_experience(inputs)
	return en_us2_search_field_experience(inputs)
});
export { search_field_experience as "search.field_experience" }